export enum SearchTypes {
  ALL = 'ALL',
  IN = 'FROM_GROUP',
  UNKNOWN = 'STRANGER',
  ADD = 'ADD_GROUP',
}
export const GEN_SEARCH_TYPES = () => [
  {
    label: '全部',
    value: SearchTypes.ALL,
    apiKey: 'totalCnt',
    badge: 0,
  },
  {
    label: '在库人员',
    value: SearchTypes.IN,
    apiKey: 'fromGroupCnt',
    badge: 0,
  },
  {
    label: '陌生人',
    value: SearchTypes.UNKNOWN,
    apiKey: 'strangerCnt',
    badge: 0,
  },
  {
    label: '添加至库',
    value: SearchTypes.ADD,
    apiKey: 'addGroupCnt',
    badge: 0,
  },
];

export enum SortTypes {
  ALL = 'ALL',
  TODAY = 'TODAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  TREE_MONTH = 'TREE_MONTH',
  OTHER = 'OTHER',
}
export const GEN_SORT_TYPES = () => [
  {
    label: '全部',
    value: SortTypes.ALL,
  },
  {
    label: '今天',
    value: SortTypes.TODAY,
  },
  {
    label: '最近7天',
    value: SortTypes.WEEK,
  },
  {
    label: '最近1月',
    value: SortTypes.MONTH,
  },
  {
    label: '最近3月',
    value: SortTypes.TREE_MONTH,
  },
];

export default {
  GEN_SEARCH_TYPES,
  GEN_SORT_TYPES,
}